/**
 * KB-META
 * Purpose: Roles
 * Role: ui.module
 * EntryPoints: 
 * Inputs: 
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=component/roles; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
export enum RoleLevel {
  SUPER_ADMIN = 0,
  CLINICIAN = 1,
  CONTENT_MANAGER = 2,
  PARTNER_ADMIN = 3,
  SECURITY_ADMIN = 4,
  ANALYTICS_ADMIN = 5,
  SUPPORT_AGENT = 6,
  AUDITOR_READONLY = 7,
  ALL = 99
}


